import React from "react";

import classNames from "classnames";

import { BetGroupOption } from "./Dropdown";

export function DropDownOption(props: {
	btOption: BetGroupOption;
	disabledOptions: string[];
}) {
	const isDisabled = props.disabledOptions.includes(props.btOption.abrv);

	return (
		<option
			value={props.btOption.abrv}
			className={classNames("offer__type__option", {
				"is-disabled": isDisabled,
			})}
			disabled={isDisabled}
		>
			{props.btOption.displayName}
		</option>
	);
}
